import Record from './base'

export class User extends Record {
  constructor(...props) {
    super(...props)
    if (this.first_name) {
      this.initials = `${this.first_name[0]}${this.last_name[0]}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/user.js